import { useHistory } from 'react-router-dom';

import { routes } from 'app/constants';
import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';
import { useBulkDeployModalContext, BULK_DEPLOY_MODALS } from 'ion-experimental/app/bulk-deploy/BulkDeployModalContext';

export default function useDeployProgressModalProps() {
  const { isDeploying, deployProgress, deployResults, handleGetPipelines } = useBulkDeployPageContext();
  const { activeModal, onCloseModal } = useBulkDeployModalContext();
  const history = useHistory();

  const isComplete = !isDeploying;
  const { completed, total } = deployProgress;
  const failedDeployments = (deployResults ?? []).filter(result => !result.success);

  // While deploying the modal is locked: backdrop / escape / close X all no-op.
  const onClose = () => {
    if (isDeploying) return;
    onCloseModal();
  };

  const onReload = () => {
    onCloseModal();
    handleGetPipelines();
  };

  const onBackToPipelines = () => {
    onCloseModal();
    history.push(routes.pipelines);
  };

  return {
    DialogProps: {
      open: activeModal === BULK_DEPLOY_MODALS.DEPLOY_PROGRESS,
      onClose,
      disableEscapeKeyDown: isDeploying,
      maxWidth: 'sm',
      fullWidth: true,
    },
    isDeploying,
    isComplete,
    completed,
    total,
    failedDeployments,
    onClose,
    onReload,
    onBackToPipelines,
  };
}
